if (!customElements.get('tp-summer-offers')) {
  customElements.define(
    'tp-summer-offers',
    class TpSummerOffers extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-tp-terms-open]')
        this.modal = this.querySelector('[data-tp-terms-modal]')
        this.dialog = this.querySelector('[data-tp-terms-dialog]')
        this.closeButtons = this.querySelectorAll('[data-tp-terms-close]')

        if (!this.openButton || !this.modal || !this.dialog) return

        this.handleOpen = this.openModal.bind(this)
        this.handleClose = this.closeModal.bind(this)
        this.handleKeydown = this.onKeydown.bind(this)

        this.openButton.addEventListener('click', this.handleOpen)
        this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose))
        document.addEventListener('keydown', this.handleKeydown)
      }

      disconnectedCallback() {
        if (!this.openButton) return

        this.openButton.removeEventListener('click', this.handleOpen)
        this.closeButtons.forEach((button) => button.removeEventListener('click', this.handleClose))
        document.removeEventListener('keydown', this.handleKeydown)

        if (!this.modal.hidden) {
          document.documentElement.style.overflow = this.previousOverflow || ''
        }
      }

      openModal() {
        this.previouslyFocused = document.activeElement
        this.previousOverflow = document.documentElement.style.overflow
        this.modal.hidden = false
        this.openButton.setAttribute('aria-expanded', 'true')
        document.documentElement.style.overflow = 'hidden'

        const closeButton = this.querySelector('.tp-summer-terms-close')
        if (closeButton) closeButton.focus()
      }

      closeModal() {
        if (this.modal.hidden) return

        this.modal.hidden = true
        this.openButton.setAttribute('aria-expanded', 'false')
        document.documentElement.style.overflow = this.previousOverflow || ''

        if (this.previouslyFocused && document.contains(this.previouslyFocused)) {
          this.previouslyFocused.focus()
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape' && !this.modal.hidden) {
          this.closeModal()
        }
      }
    }
  )
}
